import React from "react";

const LocalizationContext = React.createContext<[string | null, React.Dispatch<React.SetStateAction<string | null>>] | null>(null);
export default LocalizationContext;